export default __webpack_public_path__ + "static/media/36I-102723_-15724_0.3ec67c9f.jpg";